import { SuiteManifest } from '../manifest';
import { inventoryRoutes } from './routes';

export const inventoryManifest: SuiteManifest = {
  id: 'inventory',
  name: 'Operations & Inventory',
  basePath: '/inventory',
  icon: 'package',
  description: 'Multi-location warehouse inventory, stock balances, batches, and movements.',
  nav: [
    { label: 'Stock Balances', path: '/inventory/products', icon: 'layers', group: 'Stock', status: 'live' },
    { label: 'Field Dispatch', path: '/inventory/field-service', icon: 'wrench', group: 'Field Service', status: 'live' },
    { label: 'Warehouses', path: '/inventory/warehouses', icon: 'archive', group: 'Operations', status: 'live' },
    { label: 'Movements', path: '/inventory/movements', icon: 'shuffle', group: 'Operations', status: 'live' },
  ],
  routes: inventoryRoutes,
};

export default inventoryManifest;
